import { defaultDateTime } from "../../common/components/DateTime";
import { SEARCH_UNIVERSE, RECOMMENDABLE_TYPE } from "../constants";
import { postEventToServer } from "./postEventToServer";
import { submitRecommendationsSuccess, loadDisclaimers, loadLastDifferingRecommendation, requestClientAddressBook } from "./recordingActions";
import { CONTACT_TYPE } from "../../contacts/contactsModels";
import { hasNoDerivativeDescription } from "../models";

function toRecommendationRecoredEvent(input) {
    const now = defaultDateTime();
    const toDerivateField = (derivativeDescription) => {
        if (hasNoDerivativeDescription(derivativeDescription)) {
            return null;
        } else {
            return { description: derivativeDescription };
        }
    };

    const clients = input.clients.reduce((acc, contact) => {
        switch (contact.type) {
            case CONTACT_TYPE.ADDRESS:
                acc.push(contact.emailAddress);
                return acc;
            case CONTACT_TYPE.GROUP:
                return acc.concat(contact.contacts.map(contact => contact.emailAddress));
            default:
                throw new Error("Unknown contact type");
        }

    }, []);

    function toLegacyInstrumentClass(instrument) {
        switch (instrument.recommendableType) {
            case RECOMMENDABLE_TYPE.EQUITY:
                return "EQUITY";
            case RECOMMENDABLE_TYPE.FX_PAIR:
                return "FX";
            case RECOMMENDABLE_TYPE.BOND:
                return instrument.userProvided ? "USER_PROVIDED_BOND_INSTRUMENT" : "BOND";
            case RECOMMENDABLE_TYPE.ISSUER:
                return instrument.userProvided ? "USER_PROVIDED_BOND_ISSUER" : "BOND";
            case RECOMMENDABLE_TYPE.SOVEREIGNTY:
                return "BOND";
            case RECOMMENDABLE_TYPE.INTEREST_RATE_FUTURE:
                return "BOND";
            default:
                return null;
        }
    }

    const output = {
        communicatedVia: input.communicatedVia,
        clients,
        sendEmail: input.sendEmail,
        contactGroups: input.contactGroups.map(group => group.id),
        disseminatedOn: input.disseminatedOn ? input.disseminatedOn : now,
        recommendations: input.recommendations.map(recommendation => ({
            legs: recommendation.legs.map(leg => {
                const suppliedPrice = (leg.instrument.recommendableType == RECOMMENDABLE_TYPE.EQUITY && hasNoDerivativeDescription(leg.derivativeDescription)) ? null : leg.suppliedPrice;
                return ({
                    instrumentClass: toLegacyInstrumentClass(leg.instrument),
                    instrumentId: leg.instrument.instrumentId,
                    direction: leg.direction,
                    derivative: toDerivateField(leg.derivativeDescription),
                    marketPriceSource: suppliedPrice ? "SUPPLIED" : "INDICATIVE",
                    suppliedPrice: suppliedPrice,
                    indicativePrice: leg.instrument.indicativePrice,
                    targetPrice: leg.targetPrice
                })
            }),
            producedOn: recommendation.producedOn ? recommendation.producedOn : now,
            timeHorizon: recommendation.validityPeriod ? recommendation.validityPeriod.replace("VALIDITY_PERIOD_", "TIME_HORIZON_") : null,
            commentary: recommendation.reasoning,
            hasConflictOfInterest: recommendation.hasConflictOfInterest === "yes",
            conflictOfInterestDescription: recommendation.conflictOfInterestDescription
        }))
    };

    return output;
}

export const submitDissemination = (values, dispatch) => {
    return new Promise((resolve, reject) => {
        const event = {
            eventType: "DisseminationRecorded",
            body: toRecommendationRecoredEvent(values)
        };

        postEventToServer(event, response => {
            if (response.errors.length !== 0) {
                reject({ _error: response.errors });
            } else {
                const { id, disseminatedOn, disclosureUri, disclaimersUri, disclosuresApiUri } = response;
                values.recommendations.forEach((recommendation, recommendationIdx) => {

                    recommendation.legs.forEach((leg, legIdx) => {
                        const suffixToIdentifySpecificRecommendation = `-${recommendationIdx}-${legIdx}`;
                        const recommendationLegId = `${id}${suffixToIdentifySpecificRecommendation}`;

                        dispatch(submitRecommendationsSuccess({
                            id: recommendationLegId,
                            instrumentSymbol: (leg.instrument.symbol) ? leg.instrument.symbol : leg.instrument.name,
                            direction: leg.direction,
                            disseminatedOn,
                            disclosureUri: `${disclosureUri}${suffixToIdentifySpecificRecommendation}` }));

                        dispatch(loadLastDifferingRecommendation(recommendationLegId, `${disclosuresApiUri}${suffixToIdentifySpecificRecommendation}`));
                        dispatch(loadDisclaimers(recommendationLegId, `${disclaimersUri}${suffixToIdentifySpecificRecommendation}`));
                    });
                });

                resolve();
            }
        });
    });
};



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/actions/submitDissemination.js
 **/